module.exports = {"url":"http://wx.fadonghui.com/lvshi/App","Ueditor":"http://wx.fadonghui.com/lvshi/Ueditor"}


//////////////////
// WEBPACK FOOTER
// ./static/js/urls.json
// module id = kgPz
// module chunks = 0 1 2 3 4 5 6 7 8